<div [@enterTrigger]="'fadeIn'" class="app-modal">
  <div class="app-modal_content">
    <ng-content></ng-content>
  </div>
</div>
